import { render, staticRenderFns } from "./GLASummary.vue?vue&type=template&id=dd337648&scoped=true&"
import script from "./GLASummary.vue?vue&type=script&lang=js&"
export * from "./GLASummary.vue?vue&type=script&lang=js&"
import style0 from "./GLASummary.vue?vue&type=style&index=0&id=dd337648&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd337648",
  null
  
)

export default component.exports